import { DeleteOutlined } from "@ant-design/icons";
import * as React from "react";
import { ZBoundExtension } from "src/business/extensionBindings";
import { BlankLink } from "src/components/BlankLink";
import {
  makeMdmActionColumn,
  RenderButtonAction,
} from "src/components/MdmTable";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

export const createExtensionBindingTableColumns = (
  onRemove: (binding: ZBoundExtension) => void,
  removing: boolean,
): RtColumn<ZBoundExtension>[] => [
  {
    key: "displayId",
    title: "Display ID",
    render: ({ displayId }) => displayId,
    width: 120,
  },
  {
    key: "name",
    title: "Расширение",
    render: ({ id, name }) => (
      <BlankLink
        href={makeUrl(PageUrl.managementExtensionCard, { id })}
        title="Открыть карточку расширения в новой вкладке"
      >
        {name}
      </BlankLink>
    ),
  },
  {
    key: "description",
    title: "Описание",
    render: ({ description }) => description ?? "",
  },
  makeMdmActionColumn<ZBoundExtension>({
    key: "delete",
    render: (row) => (
      <RenderButtonAction
        icon={<DeleteOutlined />}
        isLoading={removing}
        title={`Удалить связь с расширением "${row.name}"`}
        onClick={() => onRemove(row)}
      />
    ),
  }),
];
